import styled from 'styled-components'

import EmailSignup from 'components/form/EmailSignup'

const EmailSignupWrapper = styled.div`
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
`

interface SignupProps {
  marketCode?: string
}

const Signup = ({ marketCode }: SignupProps) => (
  <EmailSignupWrapper>
    <EmailSignup
      appearance="raised"
      buttonLabel="Sign up"
      placeholder="Email address"
      solidButton
      marketCode={marketCode}
    />
  </EmailSignupWrapper>
)

export default Signup
